import { mapGetters } from 'vuex';
import ProductDetailsSimplified from 'greenmotion-shared/Components/quotes/ProductDetailsSimplified'
import Accounting from '../../mixins/accounting';

require('./scss/product-upsell.scss');

export default {
    props: [
        'product',
        'title',
        'icon',
        'isDisabled',
        'labels',
        'showTermsAndConditions',
    ],
    mixins: [Accounting],

    components: {
        ProductDetailsSimplified,
    },
    data() {
        return {
            checked: require('./images/svgs/checkbox-rounded-checked.svg'),
            unchecked: require('./images/svgs/checkbox-rounded-unchecked.svg')
        }
    },
    template: `
        <div v-if="product" @click="selectProduct(product.id)" :class="[{'product-upsell--disabled': isDisabled},'product-upsell',productUpsellClass(product)]">
            <div class="inner"
                :class="{'selected': this.selectedProduct.id === this.product.id, 'product-upsell--highlighted': product.type === 'PMP' }" 

            >
                <h4 class="title">{{ title }}</h4>

                <product-details-simplified
                    :class="{'product-details--highlighted': product.type === 'PMP' }"
                    :showTermsAndConditions="showTermsAndConditions"
                    :product="product">
                </product-details-simplified>

                <div class="product-upsell__footer">
                    <span class="product-upsell__range">
                        <img :src="icon" alt=""/>
                        {{ labels.quoteHireLength }}
                    </span>
                    <div class="product-upsell__selection">
                        <div v-if="product.total_price >= selectedProduct.total_price"  class="total">
                            &plus;&nbsp;{{ selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                        </div>
                        <div v-else  class="total">
                            &minus;&nbsp;{{ selectedPriceDiffBasePrice(selectedProduct, product, this.quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                        </div>
                        <span v-if="!isDisabled"  class="checkmark">
                            <img svg-inline :src="checkmark">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    `,
    computed: {
        ...mapGetters({
            selectedCurrency: 'selectedCurrency',
            selectedVehicle: 'getSelectedVehicle',
            selectedProduct: 'getSelectedVehicleProduct',
            quoteHireDuration: 'quoteHireDuration',
        }),
        checkmark() {
            if (this.selectedProduct.id === this.product.id) {
                return this.checked;
            }

            return this.unchecked;
        }
    },
    mounted() {
    },
    methods: {
        productUpsellClass(product) {
            return `product-upsell--${product.type}`;
        },
        selectProduct(productId) {
            if (this.isDisabled) {
                return;
            }

            this.$store.dispatch('updateVehicle', {
                selectedVehicle: this.selectedVehicle,
                productId: productId
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/Components/quotes/ProductUpsell.js